// src/utils/cardUtils.js — shared card utility functions

export function handleNameKeyDown(e, field, names, card, setCard) {
  if (e.key !== "Enter" && e.key !== "Tab") return;
  const typed = (card[field] || "").trim().toLowerCase();
  if (!typed) return;
  const match = names.find(n => n.toLowerCase().startsWith(typed));
  if (match && match.toLowerCase() !== typed) {
    if (e.key === "Enter") e.preventDefault();
    setCard(prev => ({ ...prev, [field]: match }));
  }
}

const GRADE_CLASSES = [[3, "grade-mt"], [1.5, "grade-ex"], [1, "grade-vg"],
                       [0.8, "grade-gd"], [0.4, "grade-fr"]];

function _gradeClass(g) {
  if (Number.isNaN(g)) return "grade-unknown";
  const match = GRADE_CLASSES.find(([v]) => g === v);
  return match ? match[1] : "grade-pr";
}

function _marketFactor(g, isRookie, isAuto, settings) {
  let factor;
  if (isAuto) factor = settings.auto_factor;
  else if (g === 3 && isRookie) factor = settings.rookie_mt_factor ?? settings.auto_factor;
  else if (g === 3) factor = settings.mtgrade_factor;
  else if (isRookie) factor = settings.rookie_factor;
  else {
    const gradeMap = [[1.5, "exgrade_factor"], [1, "vggrade_factor"], [0.8, "gdgrade_factor"],
                      [0.4, "frgrade_factor"], [0.2, "prgrade_factor"]];
    const entry = gradeMap.find(([v]) => g === v);
    factor = entry ? settings[entry[1]] : null;
  }
  return factor ?? null;
}

function _valueClass(v) {
  if (v == null || v < 10) return "book-low";
  if (v >= 500) return "book-high";
  if (v >= 200) return "book-highmid";
  if (v >= 50) return "book-mid";
  return "book-lowmid";
}

export function calcCardValue(card, settings) {
  const isRookie =
    card.rookie === "*" || card.rookie === "1" || Number(card.rookie) === 1 || card.rookie === true;
  const isAuto = !!(card.card_attributes?.autograph);
  const g = parseFloat(card.grade);
  const gradeClass = _gradeClass(g);

  let cardValue = null;
  if (settings) {
    const books = [
      parseFloat(card.book_high) || 0, parseFloat(card.book_high_mid) || 0,
      parseFloat(card.book_mid) || 0, parseFloat(card.book_low_mid) || 0, parseFloat(card.book_low) || 0,
    ];
    const avgBook = books.reduce((a, b) => a + b, 0) / books.length;
    const factor = _marketFactor(g, isRookie, isAuto, settings);
    if (factor !== null) cardValue = Math.round(avgBook * g * factor);
  }

  return { isRookie, g, gradeClass, cardValue, valueClass: _valueClass(cardValue) };
}
